import Timecode from 'smpte-timecode';
import msToTimecode from 'ms-to-timecode';

const RANGE = 14; // frames
const FRAME_RATE = 29.97;
const DROP_FRAME = false;

export const checkDuration = (indicated, selected) => {
  // convert selected timecode
  const selectedTC = new Timecode(selected, FRAME_RATE, DROP_FRAME);

  // define limit duration
  const rangeLimit = {
    max: new Timecode(
      msToTimecode(indicated * 1000, 30),
      FRAME_RATE,
      DROP_FRAME,
    ).add(RANGE),
    min: new Timecode(
      msToTimecode(indicated * 1000, 30),
      FRAME_RATE,
      DROP_FRAME,
    ).subtract(RANGE),
  };

  // Check selected duration is between indicated
  if (
    selectedTC.frameCount > rangeLimit.max.frameCount ||
    selectedTC.frameCount < rangeLimit.min.frameCount
  ) {
    throw new Error(`Marcações fora do limite de ${RANGE} frames`);
  }
  return selectedTC.toString();
};

export const frameToTCString = frames => {
  return new Timecode(frames, FRAME_RATE, DROP_FRAME).toString();
};
